export const safeDivide = (a: number, b: number, defaultIfImpossible: number | null | undefined = 0): number =>
	b === 0 ? defaultIfImpossible! : a / b;
